import { THUMBNAIL_WITH_GAP } from "./constants";

export const getDesktopTranslateX = (
  activeIndex,
  containerWidth,
  videosLength,
) => {
  if (!containerWidth || videosLength === 0) return 0;

  // Calculate how many thumbnails can actually fit in the current container
  const availableWidth = containerWidth - 64; // Account for padding/margins
  const visibleCount = Math.floor(availableWidth / THUMBNAIL_WITH_GAP);

  // If all thumbnails fit, no translation needed
  if (videosLength <= visibleCount) return 0;

  // Calculate maximum possible offset (when showing the last thumbnail)
  const totalCarouselWidth = videosLength * THUMBNAIL_WITH_GAP - 24; // THUMBNAIL_GAP
  const maxOffset = Math.max(0, totalCarouselWidth - availableWidth);

  // For the last video, ensure it's fully visible
  if (activeIndex >= videosLength - Math.ceil(visibleCount / 2)) {
    return maxOffset;
  }

  // For first few videos, start from beginning
  if (activeIndex < Math.floor(visibleCount / 2)) {
    return 0;
  }

  // Center the active thumbnail in view
  const centerOffset =
    (activeIndex - Math.floor(visibleCount / 2)) * THUMBNAIL_WITH_GAP;

  return Math.max(0, Math.min(maxOffset, centerOffset));
};

export const getCenterMostThumbnail = (
  mobileCarouselRef,
  thumbnailRefs,
  videosLength,
) => {
  if (!mobileCarouselRef.current || thumbnailRefs.current.length === 0)
    return 0;

  const container = mobileCarouselRef.current;
  const containerRect = container.getBoundingClientRect();
  const containerCenter = containerRect.left + containerRect.width / 2;
  const scrollLeft = container.scrollLeft;
  const scrollWidth = container.scrollWidth;
  const containerWidth = containerRect.width;

  const isAtStart = scrollLeft <= 10; // 10px tolerance
  const isAtEnd = scrollLeft >= scrollWidth - containerWidth - 10; // 10px tolerance

  if (isAtStart) return 0;
  if (isAtEnd) return videosLength - 1;

  let closestIndex = 0;
  let smallestDistance = Infinity;

  thumbnailRefs.current.forEach((thumbnail, index) => {
    if (thumbnail) {
      const thumbnailRect = thumbnail.getBoundingClientRect();
      const thumbnailCenter = thumbnailRect.left + thumbnailRect.width / 2;
      const distance = Math.abs(containerCenter - thumbnailCenter);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        closestIndex = index;
      }
    }
  });

  return closestIndex;
};
